var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"research-practice h-100"},[_c('Point'),_c('Earth',{staticClass:"h-100"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }